import { render, staticRenderFns } from "./Platings.vue?vue&type=template&id=276e6a35&scoped=true&"
import script from "./Platings.vue?vue&type=script&lang=js&"
export * from "./Platings.vue?vue&type=script&lang=js&"
import style0 from "./Platings.vue?vue&type=style&index=0&id=276e6a35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e6a35",
  null
  
)

export default component.exports